import React from "react";
import "./ProductDetails.css"; // Ümumi stillər burada

function ClothingDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="product-details">
            <h3 className="product-details-title">Geyim Məhsul Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Kateqoriya:</strong> {product.category || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Tür:</strong> {product.type || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Ölçü:</strong> {product.size || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Material:</strong> {product.material || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Brend:</strong> {product.brand || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Vəziyyət:</strong> {product.condition || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Alt kateqoriya:</strong> {product.subCategoryName || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default ClothingDetails;
